import { render, staticRenderFns } from "./RedeemComplete.vue?vue&type=template&id=623c21c3&scoped=true&"
import script from "./RedeemComplete.vue?vue&type=script&lang=js&"
export * from "./RedeemComplete.vue?vue&type=script&lang=js&"
import style0 from "./RedeemComplete.vue?vue&type=style&index=0&id=623c21c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c21c3",
  null
  
)

export default component.exports